
<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>员工中心</span><span>/</span><span>
        <router-link to="/Company/GwList">岗位列表</router-link>
      </span><span>/</span>
      <span>{{ruleForm.id?'编辑':'新建'}}岗位</span>
    </div>
    <div class="comUserInfo">
      <div class="comUserInfo-header">
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
      <div class="comUserInfo-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          style="width: 500px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="岗位名称：" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入岗位名称"></el-input>
          </el-form-item>
          <el-form-item label="岗位说明：" prop="description">
            <el-input type="textarea" autosize v-model="ruleForm.description" placeholder="请输入岗位说明"></el-input>
          </el-form-item>
          <el-form-item label="状态：" prop="state">
             <el-radio-group v-model="ruleForm.state">
                <el-radio :label="'1'">启用</el-radio>
                <el-radio :label="'0'">禁用</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var $this = this;
      return {
        rules: {
          name: [{
            required: true,
            message: '岗位名称不能为空',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '状态不能为空',
            trigger: 'blur'
          }]
        },
        ruleForm: {
          state:'1'
        }
      }
    },
    methods: {
      onSave: function() {
        var $this = this;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$axios.post('/system/gangwei/save.htm', this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                if (data.stat == '1') {
                  this.$message({
                    message: '岗位信息保存成功！',
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.go(-1);
                    }
                  });
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            return false;
          }
        });
      },
      getData: function(id) {
        this.$axios.get('/system/gangwei/load.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.ruleForm = data.data;
          } else {
            this.$message.error(data.message);
          }
        })
      }
    },
    created: function() {
      console.log(this.$route.query.id)
      if (this.$route.query.id) {
        this.getData(this.$route.query.id)
      }
    }
  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .avatar {
    width: 29.5px;
    height: 41.3px;
  }

  .orgNameSpan {
    position: absolute;
    top: 0px;
    left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Addgw.vue